export default "__VITE_ASSET__Cr_uFZ6t__"